export function publicPath(path = "/") {
  return process.env.PUBLIC_URL + path;
}
